import RoleModel from "@rolemodel/turbo-confirm"

RoleModel.start({activeClass: 'modal--active'})
